import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { BranchFilterProvider } from './contexts/BranchFilterContext';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import AdminRoute from './components/Auth/AdminRoute';
import Login from './components/Auth/Login';
import Layout from './components/Layout/Layout';
import CountryList from './components/Country/CountryList';
import CountryCreate from './components/Country/CountryCreate';
import CountryEdit from './components/Country/CountryEdit';
import CountryView from './components/Country/CountryView';
import AreaList from './components/Area/AreaList';
import AreaCreate from './components/Area/AreaCreate';
import AreaEdit from './components/Area/AreaEdit';
import AreaView from './components/Area/AreaView';
import CityList from './components/City/CityList';
import CityCreate from './components/City/CityCreate';
import CityEdit from './components/City/CityEdit';
import CityView from './components/City/CityView';
import DistrictList from './components/District/DistrictList';
import DistrictCreate from './components/District/DistrictCreate';
import DistrictEdit from './components/District/DistrictEdit';
import DistrictView from './components/District/DistrictView';
import OrganizationList from './components/Organization/OrganizationList';
import OrganizationCreate from './components/Organization/OrganizationCreate';
import OrganizationEdit from './components/Organization/OrganizationEdit';
import OrganizationView from './components/Organization/OrganizationView';
import BranchList from './components/Branch/BranchList';
import BranchCreate from './components/Branch/BranchCreate';
import BranchEdit from './components/Branch/BranchEdit';
import BranchView from './components/Branch/BranchView';
import NationalityList from './components/Nationality/NationalityList';
import NationalityCreate from './components/Nationality/NationalityCreate';
import NationalityEdit from './components/Nationality/NationalityEdit';
import NationalityView from './components/Nationality/NationalityView';
import IdentityList from './components/Identity/IdentityList';
import IdentityCreate from './components/Identity/IdentityCreate';
import IdentityEdit from './components/Identity/IdentityEdit';
import IdentityView from './components/Identity/IdentityView';
import BankList from './components/Bank/BankList';
import BankCreate from './components/Bank/BankCreate';
import BankEdit from './components/Bank/BankEdit';
import BankView from './components/Bank/BankView';
import UnitTypeList from './components/UnitType/UnitTypeList';
import UnitTypeCreate from './components/UnitType/UnitTypeCreate';
import UnitTypeEdit from './components/UnitType/UnitTypeEdit';
import UnitTypeView from './components/UnitType/UnitTypeView';
import RealEstateUsageList from './components/RealEstateUsage/RealEstateUsageList';
import RealEstateUsageCreate from './components/RealEstateUsage/RealEstateUsageCreate';
import RealEstateUsageEdit from './components/RealEstateUsage/RealEstateUsageEdit';
import RealEstateUsageView from './components/RealEstateUsage/RealEstateUsageView';
import RealEstateTypeList from './components/RealEstateType/RealEstateTypeList';
import RealEstateTypeCreate from './components/RealEstateType/RealEstateTypeCreate';
import RealEstateTypeEdit from './components/RealEstateType/RealEstateTypeEdit';
import RealEstateTypeView from './components/RealEstateType/RealEstateTypeView';
import FacilitiesAndAmenitiesList from './components/FacilitiesAndAmenities/FacilitiesAndAmenitiesList';
import FacilitiesAndAmenitiesCreate from './components/FacilitiesAndAmenities/FacilitiesAndAmenitiesCreate';
import FacilitiesAndAmenitiesEdit from './components/FacilitiesAndAmenities/FacilitiesAndAmenitiesEdit';
import FacilitiesAndAmenitiesView from './components/FacilitiesAndAmenities/FacilitiesAndAmenitiesView';
import UnitUsageList from './components/UnitUsage/UnitUsageList';
import UnitUsageCreate from './components/UnitUsage/UnitUsageCreate';
import UnitUsageEdit from './components/UnitUsage/UnitUsageEdit';
import UnitUsageView from './components/UnitUsage/UnitUsageView';
import UnitFacilitiesAndAmenitiesList from './components/UnitFacilitiesAndAmenities/UnitFacilitiesAndAmenitiesList';
import UnitFacilitiesAndAmenitiesCreate from './components/UnitFacilitiesAndAmenities/UnitFacilitiesAndAmenitiesCreate';
import UnitFacilitiesAndAmenitiesEdit from './components/UnitFacilitiesAndAmenities/UnitFacilitiesAndAmenitiesEdit';
import UnitFacilitiesAndAmenitiesView from './components/UnitFacilitiesAndAmenities/UnitFacilitiesAndAmenitiesView';
import ContractList from './components/Contract/ContractList';
import ContractCreate from './components/Contract/ContractCreate';
import ContractEdit from './components/Contract/ContractEdit';
import ContractView from './components/Contract/ContractView';
import PropertyList from './components/Property/PropertyList';
import PropertyCreate from './components/Property/PropertyCreate';
import PropertyEdit from './components/Property/PropertyEdit';
import PropertyView from './components/Property/PropertyView';
import PropertySelect from './components/Property/PropertySelect';
import Dashboard from './components/Dashboard/Dashboard';
import HomeGrid from './components/Home/HomeGrid';
import TreeBrowser from './components/Tree/TreeBrowser';
import BrokerageAgreementList from './components/BrokerageAgreement/BrokerageAgreementList';
import BrokerageAgreementCreate from './components/BrokerageAgreement/BrokerageAgreementCreate';
import BrokerageAgreementEdit from './components/BrokerageAgreement/BrokerageAgreementEdit';
import BrokerageAgreementView from './components/BrokerageAgreement/BrokerageAgreementView';
import AdditionalIncomeReportList from './components/AdditionalIncomeReport/AdditionalIncomeReportList';
import AdditionalIncomeReportCreate from './components/AdditionalIncomeReport/AdditionalIncomeReportCreate';
import AdditionalIncomeReportEdit from './components/AdditionalIncomeReport/AdditionalIncomeReportEdit';
import AdditionalIncomeReportView from './components/AdditionalIncomeReport/AdditionalIncomeReportView';
import PropertyManagementIncomeList from './components/PropertyManagementIncome/PropertyManagementIncomeList';
import PropertyManagementIncomeCreate from './components/PropertyManagementIncome/PropertyManagementIncomeCreate';
import PropertyManagementIncomeEdit from './components/PropertyManagementIncome/PropertyManagementIncomeEdit';
import PropertyManagementIncomeView from './components/PropertyManagementIncome/PropertyManagementIncomeView';
import OfficeExpenseList from './components/OfficeExpense/OfficeExpenseList';
import OfficeExpenseCreate from './components/OfficeExpense/OfficeExpenseCreate';
import OfficeExpenseEdit from './components/OfficeExpense/OfficeExpenseEdit';
import OfficeExpenseView from './components/OfficeExpense/OfficeExpenseView';
import ReceiptVoucherList from './components/ReceiptVoucher/ReceiptVoucherList';
import ReceiptVoucherCreate from './components/ReceiptVoucher/ReceiptVoucherCreate';
import ReceiptVoucherEdit from './components/ReceiptVoucher/ReceiptVoucherEdit';
import ReceiptVoucherView from './components/ReceiptVoucher/ReceiptVoucherView';
import PaidVoucherList from './components/PaidVoucher/PaidVoucherList';
import PaidVoucherCreate from './components/PaidVoucher/PaidVoucherCreate';
import PaidVoucherEdit from './components/PaidVoucher/PaidVoucherEdit';
import PaidVoucherView from './components/PaidVoucher/PaidVoucherView';
import ResidentialUnitReceiptList from './components/ResidentialUnitReceipt/ResidentialUnitReceiptList';
import ResidentialUnitReceiptCreate from './components/ResidentialUnitReceipt/ResidentialUnitReceiptCreate';
import ResidentialUnitReceiptEdit from './components/ResidentialUnitReceipt/ResidentialUnitReceiptEdit';
import ResidentialUnitReceiptView from './components/ResidentialUnitReceipt/ResidentialUnitReceiptView';
import AnnualReconciliationList from './components/AnnualReconciliation/AnnualReconciliationList';
import AnnualReconciliationCreate from './components/AnnualReconciliation/AnnualReconciliationCreate';
import AnnualReconciliationEdit from './components/AnnualReconciliation/AnnualReconciliationEdit';
import AnnualReconciliationView from './components/AnnualReconciliation/AnnualReconciliationView';
import PropertyExpenseList from './components/PropertyExpense/PropertyExpenseList';
import PropertyExpenseCreate from './components/PropertyExpense/PropertyExpenseCreate';
import PropertyExpenseEdit from './components/PropertyExpense/PropertyExpenseEdit';
import PropertyExpenseView from './components/PropertyExpense/PropertyExpenseView';
import BrokerageList from './components/Brokerage/BrokerageList';
import BrokerageCreate from './components/Brokerage/BrokerageCreate';
import BrokerageEdit from './components/Brokerage/BrokerageEdit';
import BrokerageView from './components/Brokerage/BrokerageView';
import ReceiptVoucherForm from './components/Forms/ReceiptVoucherForm';
import PaidVoucherForm from './components/Forms/PaidVoucherForm';
import ResidentialUnitReceiptForm from './components/Forms/ResidentialUnitReceiptForm';
import AnnualReconciliationForm from './components/Forms/AnnualReconciliationForm';
import './App.css';

// The landing page is the module launcher; the dashboard keeps its own route.
function Home() {
  return <HomeGrid />;
}

function App() {
  return (
    <AuthProvider>
      <BranchFilterProvider>
        <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Home />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/tree" element={<TreeBrowser />} />
          <Route path="/country" element={<AdminRoute><CountryList /></AdminRoute>} />
          <Route path="/country/create" element={<AdminRoute><CountryCreate /></AdminRoute>} />
          <Route path="/country/view/:id" element={<AdminRoute><CountryView /></AdminRoute>} />
          <Route path="/country/edit/:id" element={<AdminRoute><CountryEdit /></AdminRoute>} />
          <Route path="/area" element={<AdminRoute><AreaList /></AdminRoute>} />
          <Route path="/area/create" element={<AdminRoute><AreaCreate /></AdminRoute>} />
          <Route path="/area/view/:id" element={<AdminRoute><AreaView /></AdminRoute>} />
          <Route path="/area/edit/:id" element={<AdminRoute><AreaEdit /></AdminRoute>} />
          <Route path="/city" element={<AdminRoute><CityList /></AdminRoute>} />
          <Route path="/city/create" element={<AdminRoute><CityCreate /></AdminRoute>} />
          <Route path="/city/view/:id" element={<AdminRoute><CityView /></AdminRoute>} />
          <Route path="/city/edit/:id" element={<AdminRoute><CityEdit /></AdminRoute>} />
          <Route path="/district" element={<AdminRoute><DistrictList /></AdminRoute>} />
          <Route path="/district/create" element={<AdminRoute><DistrictCreate /></AdminRoute>} />
          <Route path="/district/view/:id" element={<AdminRoute><DistrictView /></AdminRoute>} />
          <Route path="/district/edit/:id" element={<AdminRoute><DistrictEdit /></AdminRoute>} />
          <Route path="/organization" element={<AdminRoute><OrganizationList /></AdminRoute>} />
          <Route path="/organization/create" element={<AdminRoute><OrganizationCreate /></AdminRoute>} />
          <Route path="/organization/view/:id" element={<AdminRoute><OrganizationView /></AdminRoute>} />
          <Route path="/organization/edit/:id" element={<AdminRoute><OrganizationEdit /></AdminRoute>} />
          <Route path="/branch" element={<AdminRoute><BranchList /></AdminRoute>} />
          <Route path="/branch/create" element={<AdminRoute><BranchCreate /></AdminRoute>} />
          <Route path="/branch/view/:id" element={<AdminRoute><BranchView /></AdminRoute>} />
          <Route path="/branch/edit/:id" element={<AdminRoute><BranchEdit /></AdminRoute>} />
          <Route path="/nationality" element={<AdminRoute><NationalityList /></AdminRoute>} />
          <Route path="/nationality/create" element={<AdminRoute><NationalityCreate /></AdminRoute>} />
          <Route path="/nationality/view/:id" element={<AdminRoute><NationalityView /></AdminRoute>} />
          <Route path="/nationality/edit/:id" element={<AdminRoute><NationalityEdit /></AdminRoute>} />
          <Route path="/identity" element={<AdminRoute><IdentityList /></AdminRoute>} />
          <Route path="/identity/create" element={<AdminRoute><IdentityCreate /></AdminRoute>} />
          <Route path="/identity/view/:id" element={<AdminRoute><IdentityView /></AdminRoute>} />
          <Route path="/identity/edit/:id" element={<AdminRoute><IdentityEdit /></AdminRoute>} />
          <Route path="/bank" element={<AdminRoute><BankList /></AdminRoute>} />
          <Route path="/bank/create" element={<AdminRoute><BankCreate /></AdminRoute>} />
          <Route path="/bank/view/:id" element={<AdminRoute><BankView /></AdminRoute>} />
          <Route path="/bank/edit/:id" element={<AdminRoute><BankEdit /></AdminRoute>} />
          <Route path="/unit-type" element={<AdminRoute><UnitTypeList /></AdminRoute>} />
          <Route path="/unit-type/create" element={<AdminRoute><UnitTypeCreate /></AdminRoute>} />
          <Route path="/unit-type/view/:id" element={<AdminRoute><UnitTypeView /></AdminRoute>} />
          <Route path="/unit-type/edit/:id" element={<AdminRoute><UnitTypeEdit /></AdminRoute>} />
          <Route path="/realestateusage" element={<AdminRoute><RealEstateUsageList /></AdminRoute>} />
          <Route path="/realestateusage/create" element={<AdminRoute><RealEstateUsageCreate /></AdminRoute>} />
          <Route path="/realestateusage/view/:id" element={<AdminRoute><RealEstateUsageView /></AdminRoute>} />
          <Route path="/realestateusage/edit/:id" element={<AdminRoute><RealEstateUsageEdit /></AdminRoute>} />
          <Route path="/realestatetype" element={<AdminRoute><RealEstateTypeList /></AdminRoute>} />
          <Route path="/realestatetype/create" element={<AdminRoute><RealEstateTypeCreate /></AdminRoute>} />
          <Route path="/realestatetype/view/:id" element={<AdminRoute><RealEstateTypeView /></AdminRoute>} />
          <Route path="/realestatetype/edit/:id" element={<AdminRoute><RealEstateTypeEdit /></AdminRoute>} />
          <Route path="/facilities-and-amenities" element={<AdminRoute><FacilitiesAndAmenitiesList /></AdminRoute>} />
          <Route path="/facilities-and-amenities/create" element={<AdminRoute><FacilitiesAndAmenitiesCreate /></AdminRoute>} />
          <Route path="/facilities-and-amenities/view/:id" element={<AdminRoute><FacilitiesAndAmenitiesView /></AdminRoute>} />
          <Route path="/facilities-and-amenities/edit/:id" element={<AdminRoute><FacilitiesAndAmenitiesEdit /></AdminRoute>} />
          <Route path="/unitusage" element={<AdminRoute><UnitUsageList /></AdminRoute>} />
          <Route path="/unitusage/create" element={<AdminRoute><UnitUsageCreate /></AdminRoute>} />
          <Route path="/unitusage/view/:id" element={<AdminRoute><UnitUsageView /></AdminRoute>} />
          <Route path="/unitusage/edit/:id" element={<AdminRoute><UnitUsageEdit /></AdminRoute>} />
          <Route path="/unit-facilities-amenities" element={<AdminRoute><UnitFacilitiesAndAmenitiesList /></AdminRoute>} />
          <Route path="/unit-facilities-amenities/create" element={<AdminRoute><UnitFacilitiesAndAmenitiesCreate /></AdminRoute>} />
          <Route path="/unit-facilities-amenities/view/:id" element={<AdminRoute><UnitFacilitiesAndAmenitiesView /></AdminRoute>} />
          <Route path="/unit-facilities-amenities/edit/:id" element={<AdminRoute><UnitFacilitiesAndAmenitiesEdit /></AdminRoute>} />
          <Route path="/contract" element={<ContractList />} />
          <Route path="/contract/create" element={<ContractCreate />} />
          <Route path="/contract/view/:id" element={<ContractView />} />
          <Route path="/contract/edit/:id" element={<ContractEdit />} />
          <Route path="/property-management-income" element={<PropertyManagementIncomeList />} />
          <Route path="/property-management-income/create" element={<PropertyManagementIncomeCreate />} />
          <Route path="/property-management-income/view/:id" element={<PropertyManagementIncomeView />} />
          <Route path="/property-management-income/edit/:id" element={<PropertyManagementIncomeEdit />} />
          <Route path="/property" element={<PropertyList />} />
          <Route path="/property/create" element={<PropertyCreate />} />
          <Route path="/property/view/:id" element={<PropertyView />} />
          <Route path="/property/edit/:id" element={<PropertyEdit />} />
          <Route path="/property/select" element={<PropertySelect />} />
          <Route path="/brokerage-agreement" element={<BrokerageAgreementList />} />
          <Route path="/brokerage-agreement/create" element={<BrokerageAgreementCreate />} />
          <Route path="/brokerage-agreement/edit/:id" element={<BrokerageAgreementEdit />} />
          <Route path="/brokerage-agreement/view/:id" element={<BrokerageAgreementView />} />
          <Route path="/additional-income-report" element={<AdditionalIncomeReportList />} />
          <Route path="/additional-income-report/create" element={<AdditionalIncomeReportCreate />} />
          <Route path="/additional-income-report/view/:id" element={<AdditionalIncomeReportView />} />
          <Route path="/additional-income-report/edit/:id" element={<AdditionalIncomeReportEdit />} />
          <Route path="/office-expense" element={<OfficeExpenseList />} />
          <Route path="/office-expense/create" element={<OfficeExpenseCreate />} />
          <Route path="/office-expense/view/:id" element={<OfficeExpenseView />} />
          <Route path="/office-expense/edit/:id" element={<OfficeExpenseEdit />} />
          <Route path="/receipt-voucher" element={<ReceiptVoucherList />} />
          <Route path="/receipt-voucher/create" element={<ReceiptVoucherCreate />} />
          <Route path="/receipt-voucher/view/:id" element={<ReceiptVoucherView />} />
          <Route path="/receipt-voucher/edit/:id" element={<ReceiptVoucherEdit />} />
          <Route path="/paid-voucher" element={<PaidVoucherList />} />
          <Route path="/paid-voucher/create" element={<PaidVoucherCreate />} />
          <Route path="/paid-voucher/view/:id" element={<PaidVoucherView />} />
          <Route path="/paid-voucher/edit/:id" element={<PaidVoucherEdit />} />
          <Route path="/residential-unit-receipt" element={<ResidentialUnitReceiptList />} />
          <Route path="/residential-unit-receipt/create" element={<ResidentialUnitReceiptCreate />} />
          <Route path="/residential-unit-receipt/view/:id" element={<ResidentialUnitReceiptView />} />
          <Route path="/residential-unit-receipt/edit/:id" element={<ResidentialUnitReceiptEdit />} />
          <Route path="/annual-reconciliation" element={<AnnualReconciliationList />} />
          <Route path="/annual-reconciliation/create" element={<AnnualReconciliationCreate />} />
          <Route path="/annual-reconciliation/view/:id" element={<AnnualReconciliationView />} />
          <Route path="/annual-reconciliation/edit/:id" element={<AnnualReconciliationEdit />} />
          <Route path="/brokerage" element={<BrokerageList />} />
          <Route path="/brokerage/create" element={<BrokerageCreate />} />
          <Route path="/brokerage/view/:id" element={<BrokerageView />} />
          <Route path="/brokerage/edit/:id" element={<BrokerageEdit />} />
          <Route path="/property-expense" element={<PropertyExpenseList />} />
          <Route path="/property-expense/create" element={<PropertyExpenseCreate />} />
          <Route path="/property-expense/view/:id" element={<PropertyExpenseView />} />
          <Route path="/property-expense/edit/:id" element={<PropertyExpenseEdit />} />
          <Route path="/forms/receipt-voucher" element={<ReceiptVoucherForm />} />
          <Route path="/forms/paid-voucher" element={<PaidVoucherForm />} />
          <Route path="/forms/residential-unit-receipt" element={<ResidentialUnitReceiptForm />} />
          <Route path="/forms/annual-reconciliation" element={<AnnualReconciliationForm />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
      </BranchFilterProvider>
    </AuthProvider>
  );
}

export default App;
